import React, { Component } from 'react'

import { bemClasses } from '../../utils/bem'

import './styles.scss'

class Icon extends Component {
  ALLOWED_MODIFIERS = ['small', 'medium', 'mediumHeight', 'large', 'onClick']

  componentClassNames = () => {
    return bemClasses(
      'icon',
      this.ALLOWED_MODIFIERS,
      this.props,
      this.props.className
    )
  }

  imageSource = () => {
    return `/images/icons/${this.props.icon || 'induction'}.${this.props.type || 'png'}`
  }

  render = () => {
    return (
      <span className={this.componentClassNames()} onClick={this.props.onClick}>
        <img src={this.imageSource()} alt='' />
      </span>
    )
  }
}

export default Icon
